// Only needed when it needs to be loaded before jquery.
function docReady(fn) {
    if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
    ) {
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

function headerManager() {
    var lastScrollPos = 0;
    var header = document.querySelector('.header-section');

    if (!header) return;

    window.addEventListener("scroll", function () {
        var scrollPos =
            window.pageYOffset ||
            document.documentElement.scrollTop;

        if (scrollPos > 50) {
            if (scrollPos > lastScrollPos) {
                header.classList.add('header-scroll-visability');
            } else {
                header.classList.remove('header-scroll-visability');
            }
        } else {
            header.classList.remove('header-scroll-visability');
        }

        lastScrollPos = scrollPos <= 0 ? 0 : scrollPos;
    }, false);
}

docReady(headerManager);


// Productfoto's: miniaturen laten volgen en doorbladeren na de laatste foto.
(function () {
    function connectGallery(gallery) {
        if (gallery.bnGalleryConnected) return;

        var container = gallery.querySelector('.swiper-container');
        var thumbnails = gallery.querySelector(
            '.product-medias__thumbnails'
        );

        if (!container || !thumbnails || !container.swiper) return;

        var swiper = container.swiper;
        gallery.bnGalleryConnected = true;

        function followActivePhoto() {
            if (!window.matchMedia('(max-width: 749px)').matches) return;

            var activeSlide = swiper.slides[swiper.activeIndex];
            if (!activeSlide) return;

            var media = activeSlide.querySelector('[data-media-id]');
            if (!media) return;

            var mediaId = media.getAttribute('data-media-id');
            var allThumbs = thumbnails.querySelectorAll(
                '.product-medias__thumbnail'
            );
            var activeThumb = null;

            for (var i = 0; i < allThumbs.length; i++) {
                if (
                    allThumbs[i].getAttribute('data-media-id') === mediaId
                ) {
                    activeThumb = allThumbs[i];
                    break;
                }
            }

            if (!activeThumb) return;

            var railRect = thumbnails.getBoundingClientRect();
            var thumbRect = activeThumb.getBoundingClientRect();

            thumbnails.scrollLeft +=
                thumbRect.left -
                railRect.left -
                (thumbnails.clientWidth - activeThumb.clientWidth) / 2;
        }

        swiper.on('slideChange', followActivePhoto);
        swiper.on('transitionEnd', followActivePhoto);

        var startX = null;
        var startedAtEnd = false;
        var startedAtBeginning = false;

        container.addEventListener('touchstart', function (event) {
            if (!event.touches.length) return;

            startX = event.touches[0].clientX;

            startedAtEnd =
                swiper.isEnd ||
                swiper.activeIndex >= swiper.slides.length - 1;

            startedAtBeginning =
                swiper.isBeginning ||
                swiper.activeIndex === 0;
        }, { passive: true });

        container.addEventListener('touchend', function (event) {
            if (
                startX === null ||
                !event.changedTouches.length ||
                swiper.slides.length < 2
            ) {
                startX = null;
                return;
            }

            var distance =
                event.changedTouches[0].clientX - startX;

            startX = null;

            if (Math.abs(distance) < 45) return;

            window.setTimeout(function () {
                // Veeg voorbij de laatste foto: toon de eerste.
                if (distance < 0 && startedAtEnd) {
                    swiper.slideTo(0, 0);
                }

                // Veeg vóór de eerste foto: toon de laatste.
                if (distance > 0 && startedAtBeginning) {
                    swiper.slideTo(
                        swiper.slides.length - 1,
                        0
                    );
                }

                followActivePhoto();
            }, 100);
        }, { passive: true });

        followActivePhoto();
    }

    function connectAllGalleries() {
        var galleries = document.querySelectorAll(
            '.product-images-container'
        );

        for (var i = 0; i < galleries.length; i++) {
            connectGallery(galleries[i]);
        }
    }

    function startGalleryConnection() {
        var attempts = 0;

        connectAllGalleries();

        var connectionTimer = window.setInterval(function () {
            connectAllGalleries();
            attempts++;

            if (attempts >= 120) {
                window.clearInterval(connectionTimer);
            }
        }, 250);
    }

    docReady(startGalleryConnection);

    document.addEventListener(
        'shopify:section:load',
        startGalleryConnection
    );
})();

// Broodnodig: announcementbar verbergen bij geopend mobiel menu.
(function () {
    function initializeMenuVisibility() {
        if (window.bnAppMenuVisibilityInitialized) return;
        window.bnAppMenuVisibilityInitialized = true;

        var style = document.createElement('style');

        style.textContent = `
            html.bn-app-menu-open [data-bn-vakantie-bar],
            html.bn-app-menu-open .bn-announcement-menu-hidden {
                visibility: hidden !important;
                pointer-events: none !important;
            }

            html.bn-app-menu-open .header-section,
            html.bn-app-menu-open .bn-header-floating {
                transform: none !important;
            }
        `;

        document.head.appendChild(style);

        function syncMenuVisibility() {
            var menuOpen = Boolean(
                document.querySelector('.js-drawer-open-left')
            );

            document.documentElement.classList.toggle(
                'bn-app-menu-open',
                menuOpen
            );

            document.querySelectorAll(
                '[data-bn-vakantie-bar]'
            ).forEach(function (bar) {
                var section = bar.closest('.shopify-section');

                if (section) {
                    section.classList.toggle(
                        'bn-announcement-menu-hidden',
                        menuOpen
                    );
                }
            });

            if (menuOpen) {
                document.querySelectorAll(
                    '.header-section, .bn-header-floating'
                ).forEach(function (header) {
                    header.classList.remove(
                        'header-scroll-visability',
                        'bn-header-hidden'
                    );
                });
            }
        }

        var observer = new MutationObserver(function (mutations) {
            var relevant = mutations.some(function (mutation) {
                if (mutation.type === 'childList') return true;

                var previous = mutation.oldValue || '';
                var current =
                    mutation.target.getAttribute('class') || '';

                return (
                    previous.includes('js-drawer-open-left') !==
                    current.includes('js-drawer-open-left')
                );
            });

            if (relevant) syncMenuVisibility();
        });

        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true
        });

        syncMenuVisibility();
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initializeMenuVisibility,
            { once: true }
        );
    } else {
        initializeMenuVisibility();
    }
})();